import { render, staticRenderFns } from "./StandardDropdown.vue?vue&type=template&id=c0372a9e&scoped=true&"
import script from "./StandardDropdown.vue?vue&type=script&lang=js&"
export * from "./StandardDropdown.vue?vue&type=script&lang=js&"
import style0 from "./StandardDropdown.vue?vue&type=style&index=0&id=c0372a9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0372a9e",
  null
  
)

export default component.exports